export default __webpack_public_path__ + "media/images/images_v2/pencil-ead95e7fd2e78f2a6b3ca7de9497ae2c.png";